export const SUPER_ADMIN_ROLE = 'sys-admin';

export const TRADEMARK_MANAGER = 'trademarkManager';